module.exports = __webpack_public_path__ + "static/media/nataliaw2.52edeb8c.jpg";